import { __awaiter, __generator } from "tslib";
import { uploadSmallFile } from '@office-start/graph-service';
import { UploadStatus, } from '@office-start/upload-types';
import { UploadResult } from '../models/UploadResult';
import { getUploadDestinationDriveID, getUploadDestinationPath, logFeatureForUploadHelper, } from '../utilities';
var RETRY_INTERVAL = 1000;
export var executeSimpleRetryUploadFlow = function (_a) {
    var fileUploadState = _a.fileUploadState, updateFileUploadState = _a.updateFileUploadState, graphXhrOptions = _a.graphXhrOptions, componentContext = _a.componentContext;
    return __awaiter(void 0, void 0, void 0, function () {
        var sessionId, uploadStartTime, path, driveId, uploadInProgress, uploadTry, result, timeout;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!graphXhrOptions) {
                        return [2 /*return*/, Promise.reject('Missing graphXhrOptions')];
                    }
                    if (!fileUploadState || !fileUploadState.file) {
                        return [2 /*return*/, Promise.reject('Missing file')];
                    }
                    sessionId = (componentContext === null || componentContext === void 0 ? void 0 : componentContext.sessionId) || '';
                    uploadStartTime = performance.now();
                    path = getUploadDestinationPath(fileUploadState);
                    driveId = getUploadDestinationDriveID(fileUploadState);
                    uploadInProgress = false;
                    uploadTry = function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    uploadInProgress = true;
                                    return [4 /*yield*/, uploadSmallFile({
                                            cancellationToken: fileUploadState.cancellationToken,
                                            driveId: driveId,
                                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                            file: fileUploadState.file,
                                            graphXhrOptions: graphXhrOptions,
                                            path: path,
                                            onUploadProgress: function (progress) {
                                                if (updateFileUploadState &&
                                                    fileUploadState &&
                                                    fileUploadState.sequenceNumber) {
                                                    updateFileUploadState({
                                                        sequenceNumber: fileUploadState.sequenceNumber,
                                                        progress: progress.total
                                                            ? progress.loaded / progress.total
                                                            : 0,
                                                        uploadStatus: UploadStatus.Uploading,
                                                    });
                                                }
                                            },
                                            setAutoTranscribePreferHeader: true, // set autoTranscribe prefer header to generate automatic transcripts for video uploads
                                        }).catch(function (error) {
                                            uploadInProgress = false;
                                            return error;
                                        })];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); };
                    return [4 /*yield*/, uploadTry()];
                case 1:
                    result = _b.sent();
                    timeout = function (ms) {
                        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
                    };
                    _b.label = 2;
                case 2:
                    if (!!result.docId) return [3 /*break*/, 7];
                    if (!(fileUploadState.retries &&
                        fileUploadState.retries > 0 &&
                        !uploadInProgress)) return [3 /*break*/, 5];
                    fileUploadState.retries = fileUploadState.retries - 1;
                    fileUploadState.uploadStatus = UploadStatus.Queued;
                    return [4 /*yield*/, timeout(RETRY_INTERVAL)];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, uploadTry()];
                case 4:
                    result = _b.sent();
                    return [3 /*break*/, 6];
                case 5:
                    updateFileUploadState &&
                        updateFileUploadState({
                            sequenceNumber: fileUploadState.sequenceNumber,
                            progress: 1,
                            uploadStatus: UploadStatus.Failed,
                            error: result,
                        });
                    // Logs telemetry when upload of small file has failed
                    // This happens when small file is selected and there is error in upload
                    logFeatureForUploadHelper(sessionId, UploadResult.Failed, // Logs 'IsUploadSuccessful' as 'false' if upload of small file has failed
                    uploadStartTime, fileUploadState);
                    return [2 /*return*/, Promise.reject(result)];
                case 6: return [3 /*break*/, 2];
                case 7:
                    // when upload is successful
                    if (result.docId) {
                        logFeatureForUploadHelper(sessionId, UploadResult.Success, // Logs 'IsUploadSuccessful' as 'true' if upload of small file is successful
                        uploadStartTime, fileUploadState);
                        fileUploadState.fileUrlModel = result;
                        fileUploadState.progress = 1;
                        fileUploadState.uploadStatus = UploadStatus.Completed;
                        return [2 /*return*/, fileUploadState];
                    }
                    return [2 /*return*/, fileUploadState];
            }
        });
    });
};
//# sourceMappingURL=executeSimpleRetryUploadFlow.js.map